import React from 'react'
import styled from 'styled-components'

import Article from '../Articles/Article'
import TopHeader from '../Header/TopHeader'
import MainPage from '../MainPage'
import Section from '../Sections/Section'

export interface MainPageProps {
  changeView: (searchKey: string, page: string) => void
  onClickClose?: () => void
  embedded: boolean
  className?: string
}

export const MainPageDefault = styled(MainPage)`
  border-radius: unset;
  height: 100%;
  min-height: 100%;
  overflow: auto;
  .helpHeader {
    padding: 0 10px 50px;
  }
  .topHeader {
    width: 100%;
    max-width: 1200px;
    height: 80px;
    position: relative;
    margin: 0 auto;
    @media screen and (max-width: 799px) {
      padding-top: 0;
      text-align: center;
    }
    .closeIcon {
      display: none;
    }
    .logo {
      height: 32px;
      width: auto;
      left: 0;
      @media screen and (max-width: 799px) {
        position: relative;
        display: inline-block;
        left: unset;
      }
      @media (max-width: 425px) {
        height: 28px;
        vertical-align: middle;
      }
    }
    .accessButton {
      position: absolute;
      right: 0;
      top: 30px;
      @media screen and (max-width: 799px) {
        display: none;
      }
  }
  }
`

interface SectionImplProps {
  isExternal: boolean
  searchKey: string
  changeView: (searchKey: string, page: string) => void
  embedded?: boolean
  onClickClose?: () => void
  className?: string
}

const SectionImpl = (props: SectionImplProps) => (
  <div className={props.className}>
    <TopHeader changeView={props.changeView} isExternal={props.isExternal} />
    <Section
      className={'section'}
      isExternal={props.isExternal}
      searchKey={props.searchKey}
      changeView={props.changeView}
      embedded={props.embedded}
      onClickClose={props.onClickClose}
    />
  </div>
)
export const SectionDefault = styled(SectionImpl)`
  height: 100%;
  .section {
    border-radius: unset;
    .sectionHeader {
      max-width: 940px;
      margin: 0 auto;
      padding: 50px 10px 0;
      @media (max-width: 425px) {
        padding-top: 25px;
      }
    }
    .breadCrumbs {
      padding: 0 10px;
    }
    .breadCrumbsContainer {
      max-width: 940px;
      margin: 0 auto;
      position: relative;
      .autocomplete {
        right: 0;
        height: 63px;
        &.open {
          width: 940px;
          max-width: 100%;
          right: 0;
        }
        .svg-inline--fa {
          margin: 0;
        }
      }
    }
    .sectionListLoading {
      svg {
        margin: 0;
      }
    }
    .separator {
      width: 940px;
      max-width: 100%;
      margin: 0 auto;
    }
  }
`

interface ArticleImplProps {
  searchKey: string
  isExternal: boolean
  changeView: (searchKey: string, page: string) => void
  onClickClose?: () => void
  embedded: boolean
  className?: string
  parentsArticle: string[]
  isInternal: boolean
  subArticle?: boolean
}

const ArticleImpl = (props: ArticleImplProps) => (
  <div className={props.className}>
    <TopHeader changeView={props.changeView} isExternal={props.isExternal} />
    <Article {...props} className='article' />
  </div>
)
export const ArticleDefault = styled(ArticleImpl)`
  height: 100%;
  .article {
    border-radius: unset;

    .sectionHeader {
      max-width: 940px;
      margin: 0 auto;
      padding: 50px 10px 0;
      @media (max-width: 425px) {
        padding-top: 25px;
      }
    }
    .breadCrumbs {
      padding: 0 10px;
    }
    .breadCrumbsContainer {
      max-width: 940px;
      margin: 0 auto;
      position: relative;
      .autocomplete {
        right: 0;
        height: 63px;
        &.open {
          width: 940px;
          max-width: 100%;
          right: 0;
        }
        .svg-inline--fa {
          margin: 0;
        }
      }
    }
    .articleContent {
      max-width: 940px;
      margin: 35px auto;
      padding: 0 10px;
      .subArticleContent {
        padding: 0 5px;
      }
    }
  }
`
